import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'

// Components
import AdminStoreLocationForm from './AdminStoreLocationForm'
import AdminStoreLocationEdit from './AdminStoreLocationEdit'

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'

class AdminStoreLocation extends Component {
    constructor(props) {
        super(props)
        this.props.addRoute(this.props.match)
        
        if (props.match.path === '/admin/store-locations/edit') {
            this.props.setpageTitle('Edit Store Location')
        } else {
            this.props.setpageTitle('Add Store Location')
        }
    }

    render() {
        return (
            <Switch>
                <Route path={'/admin/store-locations/add'} exact component={AdminStoreLocationForm} />
                <Route path={'/admin/store-locations/edit'} component={AdminStoreLocationEdit} />
            </Switch>
        )
    }
}


export default connect(null, { addRoute, setpageTitle })(AdminStoreLocation)



// WEBPACK FOOTER //
// ./src/components/admin/store-locations/AdminStoreLocation.js